import HenryMarketPic from "../assets/images/HenryMarketPic.webp";
import AppFoodPic from "../assets/images/AppFoodPic.webp";
import KolozoPic from "../assets/images/KolozoPic.webp";
import vidaAnimal from '../assets/images/vidaAnimalPic.webp'
import ProductPage from '../assets/images/ProductListPic.webp'
import LondoñoIngenieria from '../assets/images/londonoIngenieriaPic.webp'
import JcConstrucciones from '../assets/images/JCConstruccionesPic.webp'

export const IMAGE_BY_PROJECT = [
  {
    name: 'Henry Market',
    src: HenryMarketPic
  },
  {
    name: 'App_Food',
    src: AppFoodPic
  },
  {
    name: 'Kolozo',
    src: KolozoPic
  },
  {
    name: 'Vida_animal',
    src: vidaAnimal
  },
  {
    name: 'Products Page',
    src: ProductPage
  },
  {
    name: 'Londoño Ingenieria',
    src: LondoñoIngenieria
  },
  {
    name: 'JC Construcciones',
    src: JcConstrucciones
  }
]